import { FieldExtensionComponentProps } from "@backstage/plugin-scaffolder-react";
import { Link, type Option, Select } from "@backstage/ui";

import { useSpannerDomains } from "../hooks/useSpannerDomains";
import styles from "./SpannerDomainSelectField.module.css";

/**
 * Scaffolder field extension that renders a select input populated with
 * Spanner domain paths fetched from GitHub.
 *
 * Displays a loading placeholder while data is being fetched, and includes a
 * helper link to the Create Spanner Instance template.
 *
 * @param props - Standard scaffolder field extension component props.
 */
export const SpannerDomainSelectField = ({
    onChange,
    rawErrors,
    required,
    formData,
}: FieldExtensionComponentProps<string>) => {
    const { domains, loading } = useSpannerDomains();
    if (loading) {
        return <div>Loading spanner domains...</div>;
    }
    const options: Option[] = domains.map(path => ({
        value: path,
        label: path,
    }));
    return (
        <div>
            <Select
                label="Spanner Domain"
                isRequired={required}
                isInvalid={rawErrors?.length > 0 && !formData}
                options={options}
                value={formData}
                onChange={key => onChange(String(key))}
            />
            <p className={styles.helperText}>
                {`The domain of the data that is going to be stored in Spanner. A spanner instance must exist to create a database. Please use the `}
                <Link href="/create/templates/default/create-spanner-instance">
                    Create Spanner Instance
                </Link>
                {` template to create a new instance.`}
            </p>
        </div>
    );
};
